const color = {
    primary: "#0046FF",
    secondary: "#0046FF",
    tertiary: "#0088FF",
    quaternary: "#BAEAFA",
    light: "#FFFFFF",
    dark: "#333333",
    bodyText : '#373737',
    lightBlue: "#F5FCFF"
}

const dark = {
    primary: "#333333",
    secondary: "#4B4B4B"
}

const light = {
    primary: "#FFFFFF",
}



const fontSize = {
    'fourxl' : '6.4rem',
    'threexl' : '3.6rem',
    'twoxl' : '3.2rem',
    'xl'  : '2.4rem',
    'lg'  : '2.0rem',
    'base'  :  '1.6rem',
    'sm'   : '1.4rem',
    'xs'   : '1.2rem',
    'x'   : '1rem'

}

export const theme = {
    color,
    dark,
    light,
    fontSize
}